import { styled } from "@mui/material/styles";

export const StyledLastReadingSquare = styled("div")(({ theme }) => ({
  textAlign: "center",
  width: theme.spacing(29),
  height: theme.spacing(20),
  background: theme.palette.common.background.light,
  border: `2px dashed ${theme.palette.common.background.main}`,
  "&:hover": {
    background: theme.palette.common.background.main
  }
}));

export const StyledReadingText = styled("h2")(({ theme }) => ({
  fontWeight: "bold"
}));

export const StyledReadingInfoText = styled("h3")(({ theme }) => ({
  color: theme.palette.primary.light
}));

export const StyledSubContainer = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  flexWrap: "wrap",
  padding: theme.spacing(2.5),
  justifyContent: "center",
  marginTop: theme.spacing(-3.5)
}));

export const StyledContainer = styled("div")(({ theme }) => ({
  paddingLeft: theme.spacing(3.85)
}));

export const StyledTableContainer = styled("div")(({ theme }) => ({
  padding: theme.spacing(0.5)
}));
export default {
  StyledContainer,
  StyledSubContainer,
  StyledLastReadingSquare,
  StyledReadingText,
  StyledReadingInfoText,
  StyledTableContainer
};
